import { List, Record } from "immutable";
import type { IProViaLineData } from "common/records/ProViaLineRecord";
import { ProViaLineRecord, proViaLineFromJSON } from "common/records/ProViaLineRecord";

export interface IProViaOrder2Data {
  PONumber: string;
  OrderNo: string;
  LocationID: string;
  LocationName: string;
  LocationHandle: string;
  Vendor: string;
  JobName: string;
  EnterDate: string;
  ShipDate: string;
  DropDate: string;
  Status: string;
  CartType: string;
  User1: string;
  User2: string;
  SellPrice: string;
  SellPriceLabor: string;
  SellPriceTax: string;
  Comments: string;
  Line: IProViaLineData[];
}

export interface IProViaOrder2Record extends Omit<IProViaOrder2Data, "Line"> {
  Line: List<ProViaLineRecord>;
}

const defaultProViaOrder2Props: IProViaOrder2Record = {
  PONumber: "",
  OrderNo: "",
  LocationID: "",
  LocationName: "",
  LocationHandle: "",
  Vendor: "",
  JobName: "",
  EnterDate: "",
  ShipDate: "",
  DropDate: "",
  Status: "",
  CartType: "",
  User1: "",
  User2: "",
  SellPrice: "",
  SellPriceLabor: "",
  SellPriceTax: "",
  Comments: "",
  Line: List<ProViaLineRecord>(),
};

export class ProViaOrder2Record extends Record(defaultProViaOrder2Props) implements IProViaOrder2Record {}

export const proViaOrder2FromJSON = (json: IProViaOrder2Data): ProViaOrder2Record =>
  new ProViaOrder2Record({
    ...json,
    Line: List((json.Line || []).map(proViaLineFromJSON)),
  });
